import React from 'react';

import { ClassifyDeepfakeButton } from '@vlabs/monokit/features/classify-deepfake';
import { calcSimilarityPercent } from '@vlabs/shared/utils';
import { useTranslation } from 'react-i18next';

import { ResultSectionPanel } from '@vlabs/pages/checks/components/result-section-panel/ResultSectionPanel';

import { ResultItem } from '../../../components/result-item/ResultItem';
import { CheckTag } from '../check-tag';
import type { DeepfakeSectionProps } from './types';

function DeepfakeSection({
  value,
  frames = [],
  eventId = undefined,
}: DeepfakeSectionProps): React.JSX.Element | null {
  const { t } = useTranslation();
  const status = value?.prediction;
  if (!value) return null;

  return (
    <ResultSectionPanel title={t('Deepfake')}>
      <ResultItem label={t('checks:page.title.result')}>
        {calcSimilarityPercent(value?.score)}
        <CheckTag
          kind={status}
          value={t(`checks:result panel.results.deepfake_states.${status}`)}
        />
      </ResultItem>

      <ClassifyDeepfakeButton
        disabled={status !== 'fake'}
        frames={frames}
        key={eventId}
      />
    </ResultSectionPanel>
  );
}

export { DeepfakeSection };
